export var ModelRunRead;
(function (ModelRunRead) {
    let status;
    (function (status) {
        status["RUNNING"] = "running";
        status["OK"] = "ok";
        status["FAILED"] = "failed";
    })(status = ModelRunRead.status || (ModelRunRead.status = {}));
})(ModelRunRead || (ModelRunRead = {}));
